<div class="text-start mt-5 mt-md-6 mb-5 mb-md-8">
  @if (showGoBackLink()) {
    <mwe-button-back class="text-no-underline mb-6 d-none d-md-block" [route]="backLinkPath()" [label]="backLinkLabel()" />
  }
  <h1 class="mb-3" [innerHtml]="title() | translate" [attr.data-test]="dataTest()"></h1>
  @if (subtitle()) {
    <p class="font-size-20 text-secondary">{{ subtitle() | translate }}</p>
  }
</div>
